import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DailyHighlights from './components/DailyHighlights';
import CategoryTracking from './components/CategoryTracking';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '51爆料网 - 51爆料吃瓜与51爆料每日大赛 | 51爆料网每日爆料黑料实时追踪入口';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '51爆料网每日实时更新网红明星黑料、吃瓜大瓜与每日大赛独家爆料。提供51爆料吃瓜、黑料视频及实时追踪入口，吃瓜群众必备的看料网站。');
    }
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '51爆料网,51爆料吃瓜,51爆料每日大赛,51爆料网每日爆料,黑料实时追踪,51爆料入口,吃瓜网站,51爆料在线');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'http://heiliaobao.cn/');
    }
  }, []);

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '51爆料网首页',
          description: '51爆料网每日实时更新网红明星黑料、吃瓜大瓜与每日大赛独家爆料。提供51爆料吃瓜、黑料视频及实时追踪入口，吃瓜群众必备的看料网站。',
          url: 'http://heiliaobao.cn/',
          isPartOf: {
            '@type': 'WebSite',
            name: '51爆料网',
            url: 'http://heiliaobao.cn/',
          },
        })}
      </script>
      <main>
        <Navbar />
        <HeroSection />
        <DailyHighlights />
        <CategoryTracking />
        <Testimonials />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}